import { render, staticRenderFns } from "./order-view-title.vue?vue&type=template&id=73421e0b&scoped=true&"
import script from "./order-view-title.ts?vue&type=script&lang=ts&"
export * from "./order-view-title.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73421e0b",
  null
  
)

export default component.exports